import * as t from 'io-ts';

export const UserProfileAddressType = t.interface({
    zipCode: t.union([t.string, t.null, t.undefined]),
    localityId: t.union([t.string, t.null, t.undefined]),
    regionName: t.union([t.string, t.null, t.undefined]),
    addressString: t.union([t.string, t.null, t.undefined]),
});

export interface UserProfileAddressDto extends t.TypeOf<typeof UserProfileAddressType> {
}

class UserProfileAddress {
    zipCode: string | null;
    localityId: string | null;
    regionName: string | null;
    addressString: string | null;

    constructor(params: UserProfileAddressDto) {
        this.zipCode = params.zipCode ?? null;
        this.localityId = params.localityId ?? null;
        this.regionName = params.regionName ?? null;
        this.addressString = params.addressString ?? null;
    }
}

export default UserProfileAddress;
